// extracted by mini-css-extract-plugin
export var bodyRow = "_e9-d";
export var cardColumns = "_e9-e";
export var ellipsesOverflow = "_e9-2";
export var flatBottomCorners = "_e9-3";
export var flatTopCorners = "_e9-4";
export var headerActionsDropdown = "_e9-f";
export var headerBottomRow = "_e9-c";
export var headerTopRow = "_e9-b";
export var orderDetailsWrapper = "_e9-0";
export var orderInfoContainer = "_e9-1";
export var productDetails = "_e9-9";
export var productImage = "_e9-5";
export var responsiveTable = "_e9-8";
export var shipmentContainer = "_e9-a";
export var tableBottomLeft = "_e9-6";
export var tableBottomRight = "_e9-7";